module.exports = __webpack_public_path__ + "img/ic_benifit_audio.47fa636d.png";